import './Home.css'
import { useEffect } from 'react'
import Intro from '../../section/Intro/Intro'
import About from '../../section/About/About'
import Services from '../../section/Services/Services'
import State from '../../section/State/State'
import { Api } from '../../Api/Api'
const Home = () => {
  useEffect(() => {
    (async () => {
      const res1 = await fetch(`${Api}/views`)
      const data = await res1.json()
      var num = data.counter

      await fetch(`${Api}/views`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ counter: num + 1 })
      })
    })();
  })
  return (
    <>
      <Intro />
      <About />
      <Services />
      <State />
    </>
  )
}

export default Home